import React, { useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../images/services-usa/machine-learning-company/ml-banner.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service healthcare_banner android_banner nft_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={8} lg={8} xl={8} xxl={7} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner" style={{ marginBottom: "10px" }}>
                Machine Learning Development Services
              </h1>
              <span>High-Throughput ML for Predictive Excellence</span>
              <p>
                Maximize predictive power across business functions for
                decisive, data-focused decision-making at every step. Our
                machine learning development company helps develop performant
                models that reduce operational complexities, generating
                automated, more accurate projections – from customer churn
                prediction to fraud prevention.
              </p>

              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Consult ML Solutions
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
